import React, { useState, useEffect } from 'react';
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';
import ErrorsTable from '../../components/FormPage/VersionErrorTable';
import LoggingTable from '../../components/FormPage/VersionLoggingTable';

const MonitorContainer = ( { version }) => {
  const [errorsData, setErrorsData] = useState([]);
  const [loggingData, setLoggingData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState('logging');

  const fetchData = async () => {
    try {
      const errorsResponse = await axios.get(`/api/errors/${version}`);
      const loggingResponse = await axios.get(`/api/logging/${version}`); // Replace with actual version
      setErrorsData(errorsResponse.data);
      setLoggingData(loggingResponse.data);
    } catch (error) {
      toast.error('Failed to fetch data');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [version]);

  const getTabClass = (providedTab) => {
	  return providedTab === tab ?
		  "inline-block p-4 text-purple-500 bg-gray-400 rounded-t-lg active"
		  :
	      "inline-block p-4 rounded-t-lg hover:text-gray-600 hover:bg-gray-300"
  }

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className="p-5 ml-5 mb-10 bg-white shadow">
        <div className="px-2 py-3">
            <ul class="flex flex-wrap text-lg font-medium text-center text-gray-500 border-b border-gray-400 mb-5">
              <li class="mr-3">
                  <button onClick={() => setTab('logging')}aria-current="page" className={getTabClass('logging')}>Logging</button>
              </li>
              <li class="mr-3">
                  <button onClick={() => setTab('error')}className={getTabClass('error')}>Errors</button>
              </li>
            </ul>
            { tab === "logging" && (
                <LoggingTable data={loggingData} />
            )}
            { tab === "error" && (
                <ErrorsTable data={errorsData} />
            )}
        </div>
        <ToastContainer />
    </div>
  );
};

export default MonitorContainer;

